import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

// material-ui
import { useTheme } from "@mui/material/styles";
import { Avatar, Badge, Box, ButtonBase } from "@mui/material";
// import { GiScooter } from "react-icons/gi";
// project imports
import LogoSection from "../LogoSection";
import SearchSection from "./SearchSection";
import ProfileSection from "./ProfileSection";
// import NotificationSection from "./NotificationSection";
// import RightSideBarState from "../../../zastand/rightSidePanel.zastand";
import RightSideBarStateRecent from "../../../zastand/rightSidePanelRecent.zastand";
import RightSideBarStateSocket from "../../../zastand/rightSidePanelSocket.zastand";

// import NotificationsButton from "../../../ui-helper/buttons/NotificationsButton";
// assets
import { IconBrandSocketIo, IconMenu2, IconNews } from "@tabler/icons";
// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = ({
  handleLeftDrawerToggle,
  badgeContent,
  initialNotificationCount,
}) => {
  const [, setNotificationCount] = useState(initialNotificationCount || 0);
  const updateNotificationCount = (newCount) => {
    setNotificationCount(newCount);
  };
  const theme = useTheme();

  // const setRightSidebar = RightSideBarState((state) => state.setRightSideBar);
  const setRightSidebarSocket = RightSideBarStateSocket(
    (state) => state.setRightSideBarSocket
  );
  const setRightSidebarRecent = RightSideBarStateRecent(
    (state) => state.setRightSideBarRecent
  );
  // const rightSidebar = RightSideBarState((state) => state.rightSideBar);
  const rightSidebarSocket = RightSideBarStateSocket(
    (state) => state.rightSideBarSocket
  );
  const rightSidebarRecent = RightSideBarStateRecent(
    (state) => state.rightSideBarRecent
  );

  useEffect(() => {
    updateNotificationCount(badgeContent);
  }, [badgeContent]);

  const [socketCount, setSocketCount] = useState(0);
  useEffect(() => {
    setSocketCount(localStorage.getItem("socketCount"));
  }, []);

  const [, setordersCount] = useState(0);
  useEffect(() => {
    setordersCount(localStorage.getItem("ordersCount"));
  }, []);

  return (
    <>
      {/* logo & toggler button */}
      <Box
        sx={{
          width: 228,
          display: "flex",
          [theme.breakpoints.down("md")]: {
            width: "auto",
          },
        }}
      >
        <Box
          component="span"
          sx={{ display: { xs: "none", md: "block" }, flexGrow: 1 }}
        >
          <LogoSection />
        </Box>
        <ButtonBase sx={{ borderRadius: "12px", overflow: "hidden" }}>
          <Avatar
            variant="rounded"
            sx={{
              ...theme.typography.commonAvatar,
              ...theme.typography.mediumAvatar,
              transition: "all .2s ease-in-out",
              background: theme.palette.secondary.light,
              color: theme.palette.secondary.dark,
              "&:hover": {
                background: theme.palette.secondary.dark,
                color: theme.palette.secondary.light,
              },
            }}
            onClick={handleLeftDrawerToggle}
            color="inherit"
          >
            <IconMenu2 stroke={1.5} size="1.3rem" />
          </Avatar>
        </ButtonBase>
      </Box>

      {/* header search */}
      <SearchSection />
      <Box sx={{ flexGrow: 1 }} />
      <Box sx={{ flexGrow: 1 }} />

      {/* notification & profile */}
      {/* <NotificationSection /> */}

      {/* <div
        style={{
          marginRight: "1rem",
          // backgroundColor: "#D4E2D4",
          padding: ".1rem",
          borderRadius: ".7rem",
        }}
        onClick={() => {
          updateNotificationCount(notificationCount + 1);
          setRightSidebarRecent(false);
          setRightSidebarSocket(false);
          setRightSidebar(!rightSidebar);
        }}
      >
 
        <Badge badgeContent={ordersCount} color="primary">
          <ButtonBase sx={{ borderRadius: "12px" }}>
            <Avatar
              variant="rounded"
              sx={{
                ...theme.typography.commonAvatar,
                ...theme.typography.mediumAvatar,
                transition: "all .2s ease-in-out",
                background: theme.palette.secondary.light,
                color: theme.palette.secondary.dark,
                '&[aria-controls="menu-list-grow"],&:hover': {
                  background: theme.palette.secondary.dark,
                  color: theme.palette.secondary.light,
                },
              }}
              aria-haspopup="true"
              color="inherit"
            >
              <IconBell stroke={1.5} size="1.3rem" />
            </Avatar>
          </ButtonBase>
        </Badge>
      </div> */}

      <div
        style={{
          marginRight: "1rem",
          // backgroundColor: "#D4E2D4",
          padding: ".1rem",
          borderRadius: ".7rem",
        }}
        onClick={() => {
          setRightSidebarRecent(false);
          setRightSidebarSocket(!rightSidebarSocket);
          // setRightSidebar(false);
        }}
      >
        <Badge badgeContent={socketCount} color="primary">
          <ButtonBase sx={{ borderRadius: "12px" }}>
            <Avatar
              variant="rounded"
              sx={{
                ...theme.typography.commonAvatar,
                ...theme.typography.mediumAvatar,
                transition: "all .2s ease-in-out",
                background: theme.palette.secondary.light,
                color: theme.palette.secondary.dark,
                '&[aria-controls="menu-list-grow"],&:hover': {
                  background: theme.palette.secondary.dark,
                  color: theme.palette.secondary.light,
                },
              }}
              aria-haspopup="true"
              color="inherit"
            >
              <IconBrandSocketIo stroke={1.5} size="1.3rem" />
            </Avatar>
          </ButtonBase>
        </Badge>
      </div>

      {/* <div
        style={{
          marginRight: "1rem",
          // backgroundColor: "#D4E2D4",
          padding: ".1rem",
          borderRadius: ".7rem",
        }}
        onClick={() => {
          setRightSidebarRecent(!rightSidebarRecent);
          setRightSidebarSocket(false);
          // setRightSidebar(false);
        }}
      >
        <ButtonBase sx={{ borderRadius: "12px" }}>
          <Avatar
            variant="rounded"
            sx={{
              ...theme.typography.commonAvatar,
              ...theme.typography.mediumAvatar,
              transition: "all .2s ease-in-out",
              background: theme.palette.secondary.light,
              color: theme.palette.secondary.dark,
              '&[aria-controls="menu-list-grow"],&:hover': {
                background: theme.palette.secondary.dark,
                color: theme.palette.secondary.light,
              },
            }}
            aria-haspopup="true"
            color="inherit"
          >
            <IconNews stroke={1.5} size="1.3rem" />
          </Avatar>
        </ButtonBase>
      </div> */}

      <ProfileSection />
    </>
  );
};

Header.propTypes = {
  handleLeftDrawerToggle: PropTypes.func,
  initialNotificationCount: PropTypes.number,
  badgeContent: PropTypes.number,
};

export default Header;
